import { Component } from '@angular/core';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-competition-edit-button-cell',
  templateUrl: './competition-edit-button-cell.component.html',
  styleUrls: ['./competition-edit-button-cell.component.css'],
})
export class CompetitionEditButtonCellComponent implements AgRendererComponent {
  competitionId: string;

  faEdit = faEdit;
  constructor() {}
  refresh(params: ICellRendererParams): boolean {
    this.competitionId = params.data.id;
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.competitionId = params.data.id;
  }
}
